<template>
      <ul class="nav nav-tabs justify-content-center custom-secondary-nav">
        <li class="nav-item">
          <!-- <a class="nav-link active" href="#">Link 1</a> -->
          <router-link class="nav-link" v-bind:class="{ active: (index==1) }" :to="{ name: 'courses' }">Все</router-link>
        </li>
        <li class="nav-item">
          <!-- <a class="nav-link" href="#">Link 2</a> -->
          <router-link class="nav-link" v-bind:class="{ active: (index==2) }" :to="{ name: 'courses_inprogress' }">В процессе</router-link>
        </li>
        <li class="nav-item">
          <!-- <a class="nav-link" href="#">Link 3</a> -->
          <router-link class="nav-link" v-bind:class="{ active: (index==3) }" :to="{ name: 'courses_done' }">Завершённые</router-link>
        </li>
      </ul>
    <!--
    <div class="row pl-3 pr-3">
        <div v-bind:class="{ highlighted: (index==1) }" class="col col-md-4 border text-center" id="courses_menu_all">
            <router-link class="navbar-brand" :to="{ name: 'courses' }">Все</router-link>
        </div>
        <div v-bind:class="{ highlighted: (index==2) }" class="col col-md-4 border text-center" id="courses_menu_inprogress">
            <router-link class="navbar-brand" :to="{ name: 'courses_inprogress' }">В процессе</router-link>
        </div>
        <div v-bind:class="{ highlighted: index==3 }" class="col col-md-4 border text-center" id="courses_menu_done">
            <router-link class="navbar-brand" :to="{ name: 'courses_done' }">Завершённые</router-link>
        </div>
    </div>
    -->
</template>
<script>
export default {
    props: ['index'],

}
</script>
<style scoped>
/*
    .highlighted {
        background-color: pink;
    }
*/
</style>
